import { AppConfigurationKey } from '../../../../model/enums/appConfigurationKey'
import { getActiveBalanceZone, getAppConfigurationValue } from '../../../../redux'
import AxiosInstance from '../../../http-config'
import moment from 'moment'
import { 
  StatusBalanceResponse,
  OperacionCalculo,
  Balance,
  RecuperarBalanceModelResponse,
  RecuperarBalanceModelRequest,
 } from '../../model'
import { GuardarBalanceModelRequest } from '../requests/guardarBalance.request'
import { CalculoBalanceRequest } from '../requests/calculoBalance.request'

export class ApiBalancePioneer {

    getStatusBalance = async () : Promise<StatusBalanceResponse> => {
    const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.ApiUrlSuffixPioneer);

    return await AxiosInstance.get(
      `${apiSuffixUrl}/api/Balance/GetBalanceStatus`
    ).then(response => {
      return response.data;
    });
  };
  
  fetch = async (): Promise<Balance[]> => {
    const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.ApiUrlSuffixPioneer)
    const activeBalanceZone = getActiveBalanceZone()?.id

    return await AxiosInstance.get(`${apiSuffixUrl}/api/Balance/GetBalances?balanceZone=${activeBalanceZone}`).then(
      response => {
        return response.data
      }
    )
  }

  get = async (
    request: RecuperarBalanceModelRequest
  ): Promise<Array<RecuperarBalanceModelResponse>> => {
      const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.ApiUrlSuffixPioneer)
    return await AxiosInstance.post(
      `${apiSuffixUrl}/api/Balance/RecuperarBalance`, request
    ).then(response => {
      return response.data
    })
  }

  save = async (request: GuardarBalanceModelRequest) => {
    const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.ApiUrlSuffixPioneer)
    
    return await AxiosInstance.post(
      `${apiSuffixUrl}/api/Balance/GuardarBalance`,
      request
    ).then(response => {
      return response
    })
  }

  getCalculation = async (request: CalculoBalanceRequest): Promise<OperacionCalculo[]> => {
    const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.ApiUrlSuffixPioneer)
    
    return await AxiosInstance.post(
      `${apiSuffixUrl}/api/Balance/CalculoBalance`,
      request
    ).then(response => {
      return response.data
    })
  }  
}
